import { useContext, useEffect, useState } from "react";

import { HotelSearchContext } from "../../contexts/HotelSearchContext";
import { HotelSearchRoom } from "../../types/HotelType";

import styles from "./hotelQuantityPicker.module.scss";

export const initialRoomValues:HotelSearchRoom[] =   [{
    room_number: 1,
    adultsQty: 1,
    childrenQty: 0,
    childrenAges: [] as Array<number>,
    infantsQty: 0,
}]

export function HotelQuantityPicker() {

    const { hotelSearchRooms, setHotelSearchRooms } = useContext(HotelSearchContext);
    const [rooms, setRooms] = useState<HotelSearchRoom[]>(() => hotelSearchRooms.length === 0 ? initialRoomValues : hotelSearchRooms);

    useEffect(()=>{
        setHotelSearchRooms(rooms);
        if (hotelSearchRooms.length === 0) {
            setRooms(initialRoomValues);
            setHotelSearchRooms(initialRoomValues);
            rooms.map((room) => {
                room.childrenQty = 0
                room.childrenAges = []
                room.infantsQty = 0
                room.adultsQty = 1
            })
            updateLocalStorage(initialRoomValues);
        }
        updateLocalStorage(rooms)
    },[hotelSearchRooms.length, rooms, setHotelSearchRooms]);



    const updateLocalStorage = (roomsSearch:HotelSearchRoom[]) => {
        window.localStorage.setItem('roomsData', JSON.stringify(roomsSearch));
    }

    const addRoom = () => {
        const newRoom = {
            room_number: rooms.length + 1,
            adultsQty: 1,
            childrenQty: 0,
            childrenAges: [],
            infantsQty: 0,
        };
        setRooms([...rooms, newRoom]);
    };

    const removeRoom = (index: number) => {
        const roomToRemove = [...rooms];
        roomToRemove.splice(index, 1);
        setRooms(roomToRemove);
    };

    const onChangeChildAges = (index: number, childrenAges: number, index2: number) => {
        const newRooms = [...rooms];
        newRooms[index]['childrenAges'][index2] = childrenAges;
        setRooms(newRooms);
    };


    const onChangeQty = (ageGroup: 'adultsQty' | 'childrenQty' | 'infantsQty', index: number, qty: number) => {
        const newRooms = [...rooms];
        newRooms[index][ageGroup] = qty;
        setRooms(newRooms);
    }

    let childrenAgeRange: String[] = [];
    for (let i = 3; i <= 17; i++) childrenAgeRange.push(i.toString());

    return <div className={styles.roomWrapper}>
        {rooms.map((room: HotelSearchRoom, index: number) => {
            return (
                <div className={styles.room} key={index}>
                    <div className={styles.roomHolder}>
                        <div className={styles.roomTitle}>
                        <h4>Room {index + 1} </h4>
                        {rooms.length === 1 ? '' : <button aria-label={`remove room number ${index + 1}`} className={styles.roomBtnsRemoveNew} onClick={() => removeRoom(index)}>Remove</button>}
                        </div>
                        <div className={styles.container}>
                            <div className={styles.qtyChangerContainer}>
                                <div className={styles.pickerContainer}>
                                    <p>Adults</p>
                                    <div className={`${styles.quantityPicker} ${styles.quantityPickerAdult}`}>
                                        <button
                                            aria-label={`decrease adult quantity in room number ${index + 1}`}
                                            onClick={() => { room.adultsQty > 1 ? onChangeQty('adultsQty', index, room.adultsQty - 1) : null; }}
                                            className={`${styles.qtyChanger} ${styles.qtyChangerRemove} ${room.adultsQty === 1 ? styles.qtyChangerDisabled : ""}`}
                                            disabled={room.adultsQty === 1 ? true : false}
                                        ><span className={styles.visuallyHidden}>Remove an adult</span></button>
                                        <span className={styles.qty} aria-live="polite"><span className={styles.visuallyHidden}>Number of adult guests in Room {index + 1} is </span>{room.adultsQty}</span>
                                        <button
                                            aria-label={`increase adult quantity in room number ${index + 1}`}
                                            onClick={() => { room.adultsQty < 9 ? onChangeQty('adultsQty', index, room.adultsQty + 1) : null; }}
                                            className={`${styles.qtyChanger} ${styles.qtyChangerAdd} ${room.adultsQty === 9 ? styles.qtyChangerDisabled : ""}`}
                                            disabled={room.adultsQty === 9 ? true : false}
                                        ><span className={styles.visuallyHidden}>Add an adult</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.qtyChangerContainer}>
                                <div className={styles.pickerContainer}>
                                    <p>Children (3-17yrs)</p>
                                    <div className={`${styles.quantityPicker} ${styles.quantityPickerChild}`}>
                                        <button
                                            aria-label={`decrease children quantity in room number ${index + 1}`}
                                            onClick={() => {
                                                room.childrenQty > 0 ? onChangeQty('childrenQty', index, room.childrenQty - 1) : null;
                                                room.childrenAges.pop();
                                            }}
                                            className={`${styles.qtyChanger} ${styles.qtyChangerRemove} ${room.childrenQty === 0 ? styles.qtyChangerDisabled : ""}`}
                                            disabled={room.childrenQty === 0 ? true : false}
                                        ><span className={styles.visuallyHidden}>Remove a child</span></button>
                                        <span className={styles.qty} aria-live="polite"><span className={styles.visuallyHidden}>Number of child (3-17yrs) guests in Room {index + 1} is </span>{room.childrenQty}</span>
                                        <button
                                            aria-label={`increase children quantity in room number ${index + 1}`}
                                            onClick={() => { room.childrenQty < 9 ? onChangeQty('childrenQty', index, room.childrenQty + 1) : null; }}
                                            className={`${styles.qtyChanger} ${styles.qtyChangerAdd} ${room.childrenQty === 9 ? styles.qtyChangerDisabled : ""}`}
                                            disabled={room.childrenQty === 9 ? true : false}
                                        ><span className={styles.visuallyHidden}>Add a child</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.qtyChangerContainer}>
                                <div className={styles.pickerContainer}>
                                    <p>Infants (0-2yrs)</p>
                                    <div className={`${styles.quantityPicker} ${styles.quantityPickerInfant}`}>
                                        <button
                                            aria-label={`decrease infants quantity in room number ${index + 1}`}
                                            onClick={() => { room.infantsQty > 0 ? onChangeQty('infantsQty', index, room.infantsQty - 1) : null; }}
                                            className={`${styles.qtyChanger} ${styles.qtyChangerRemove} ${room.infantsQty === 0 ? styles.qtyChangerDisabled : ""}`}
                                            disabled={room.infantsQty === 0 ? true : false}
                                        ><span className={styles.visuallyHidden}>Remove an infant</span></button>
                                        <span className={styles.qty} aria-live="polite"><span className={styles.visuallyHidden}>Number of infant (0-2yrs) guests in Room {index + 1} is </span>{room.infantsQty}</span>
                                        <button
                                            aria-label={`increase infants quantity in room number ${index + 1}`}
                                            onClick={() => {
                                                room.infantsQty < 2 ? onChangeQty('infantsQty', index, room.infantsQty + 1) : null;
                                            }}
                                            className={`${styles.qtyChanger} ${styles.qtyChangerAdd} ${room.infantsQty === 2 ? styles.qtyChangerDisabled : ""}`}
                                            disabled={room.infantsQty === 2 ? true : false}
                                        ><span className={styles.visuallyHidden}>Add an infant</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.childrenAge}>
                            {Array.from(Array(room.childrenQty)).map((c, index2) => {
                                return <div key={index2} className={styles.childrenAgePicker}>
                                    <label htmlFor={`childage${index2 + 1}`}>Child {index2 + 1} age</label>
                                    <select id={`childage${index2 + 1}`} className={styles.childAgeSelect} onChange={(e) => onChangeChildAges(index, +e.target.value, index2)} value={rooms[index].childrenAges[index2] ? rooms[index].childrenAges[index2].toString() : rooms[index].childrenAges[index2] = 3}>
                                        {childrenAgeRange.map((num, index3) => { return <option key={index3} value={num.toString()}>{num}</option>; })}
                                    </select>
                                </div>;
                            })}
                        </div>
                        <div className={styles.roomBtns}>
                        {rooms.length === 4 ? '' : <button aria-label={`add room`} className={styles.roomBtnsAdd} onClick={addRoom}>Add room</button>}
                        {rooms.length === 1 ? '' : <button aria-label={`remove room number ${index + 1}`} className={styles.roomBtnsRemove} onClick={() => removeRoom(index)}>Remove room</button>}
                        </div>
                    </div>
                    <div className={styles.roomBtnsNew}>
                    {rooms.length === 4 ? '' : <button aria-label={`add room number ${index + 2}`} className={`${styles.roomBtnsAddNew} ${index + 1 < rooms.length ? styles.roomBtnWithRemove : ""}`} onClick={addRoom}>Add room</button>}
                    </div>
                </div>
                );
        })}
    </div>;
}


